import type { ParsedQuote } from "../types";

// Parse multiple quotes from text input
export function parseQuotes(input: string): ParsedQuote[] {
  const lines = input
    .split("\n")
    .map((line) => line.trim())
    .filter((line) => line.length > 0);

  return lines.map(parseSingleQuote);
}

// Parse a single quote line, detecting author separation
export function parseSingleQuote(line: string): ParsedQuote {
  // Remove surrounding quotes if present
  let text = line.replace(/^[""]|[""]$/g, "").trim();

  // Try to detect author separator patterns
  // Patterns: " — Author", " - Author", " ~ Author", " by Author"
  const separatorPatterns = [
    /\s*[—–-]\s*([^—–-]+)$/,  // em dash, en dash, or hyphen
    /\s*~\s*([^~]+)$/,          // tilde
    /\s+by\s+([^,]+)$/i,        // "by Author"
  ];

  let author: string | undefined;

  for (const pattern of separatorPatterns) {
    const match = text.match(pattern);
    if (match) {
      author = match[1].trim();
      text = text.replace(pattern, "").trim();
      break;
    }
  }

  // Clean up any remaining quotes
  text = text.replace(/^[""]|[""]$/g, "").trim();

  return { text, author };
}

// Format quote for display
export function formatQuote(quote: ParsedQuote): string {
  if (quote.author) {
    return `"${quote.text}" — ${quote.author}`;
  }
  return `"${quote.text}"`;
}
